import React, { useState } from 'react';
import { TouchableOpacity, FlatList } from 'react-native';

import RadioButton from '@components/RadioButton/RadioButton';
import { Box, ShadowBox, Text } from '@components/Restyle';
import { TaskSortOption } from '@graphql/generated';

export type PopupTaskSortPopBoxV3Props = {
  selectedSorts?: TaskSortOption[];
  onSelectedSorts?: (x: TaskSortOption[]) => void;
  allowedSortIds?: TaskSortOption[];
};

export const FilterOptionsData = [
  {
    id: 'due',
    title: 'Due Date',
    children: [
      {
        title: 'Soonest',
        id: TaskSortOption.DueDateAsc,
      },
      { title: 'Latest', id: TaskSortOption.DueDateDesc },
    ],
  },
  {
    id: 'priority',
    title: 'Priority',
    children: [
      {
        title: 'Low to High',
        id: TaskSortOption.PriorityAsc,
      },
      {
        title: 'High to Low',
        id: TaskSortOption.PriorityDesc,
      },
    ],
  },
  {
    id: 'last-updated',
    title: 'Last Updated',
    children: [
      {
        title: 'Newest',
        id: TaskSortOption.UpdatedAtDesc,
      },
      {
        title: 'Oldest',
        id: TaskSortOption.UpdatedAtAsc,
      },
    ],
  },
  {
    id: 'created',
    title: 'Created Date',
    children: [
      {
        title: 'Newest',
        id: TaskSortOption.CreatedAtDesc,
      },
      {
        title: 'Oldest',
        id: TaskSortOption.CreatedAtAsc,
      },
    ],
  },
];

export const PopupTaskSortPopBoxV3: React.FC<PopupTaskSortPopBoxV3Props> = ({
  selectedSorts = [],
  onSelectedSorts,
  allowedSortIds,
}) => {
  const visibleData = allowedSortIds
    ? FilterOptionsData.map((group) => ({
        ...group,
        children: group.children.filter((child) =>
          allowedSortIds.includes(child.id)
        ),
      })).filter((group) => group.children.length > 0)
    : FilterOptionsData;
  const handleOptionSelect = (sort?: TaskSortOption) => {
    // onSelectedIds?.([
    //   ...selectedIds.filter((t) => !t.startsWith(parentId)),
    //   childId,
    // ]);
    if (sort) {
      onSelectedSorts?.([sort]);
    } else {
      onSelectedSorts?.([]);
    }
  };

  // Common title bar with animated chevron
  const titleBar = (title: string) => {
    return (
      <Box flexDirection='row' alignItems='center' height={37} px='m'>
        <Text
          flex={1}
          variant='labelEmphasized'
          color='textSecondary'
          numberOfLines={1}>
          {title}
        </Text>
      </Box>
    );
  };
  const [hoveredId, setHoveredId] = useState<string | undefined>();
  const renderItem = ({ item }) => (
    <Box>
      {titleBar(item.title)}

      {item.children.map((child) => (
        <TouchableOpacity
          key={child.id}
          onPress={() => handleOptionSelect(child.id)}>
          <Box
            borderLeftWidth={1}
            borderLeftColor='grey02'
            borderRightWidth={1}
            borderRightColor='grey02'
            flexDirection='row'
            px='m'
            py='xs'
            alignItems='center'
            backgroundColor={hoveredId === child.id ? 'grey01' : 'white'}
            onMouseEnter={() => {
              setHoveredId(child.id);
            }}
            onMouseLeave={() => {
              setHoveredId(undefined);
            }}>
            <RadioButton
              iconVariant='m'
              isSelected={selectedSorts.some((t) => t === child.id)}
              onPress={() => {
                handleOptionSelect(child.id);
              }}></RadioButton>
            <Text
              ml='xs'
              flex={1}
              variant='webBodySecondary'
              color='textSecondary'
              numberOfLines={1}>
              {child.title}
            </Text>
          </Box>
        </TouchableOpacity>
      ))}
    </Box>
  );

  return (
    <ShadowBox
      flex={1}
      width={380}
      alignItems='center'
      justifyContent='center'
      borderRadius='xs'
      borderWidth={1}
      borderColor='grey02'
      variant='base'
      backgroundColor='white'>
      <Box flex={1} style={{ width: 380 }}>
        <FlatList
          data={visibleData}
          renderItem={renderItem}
          keyExtractor={(item) => item.id}
          scrollEnabled={false}
        />
      </Box>
      <Box
        width={380}
        borderTopWidth={1}
        borderTopColor='grey02'
        height={48}
        alignItems='center'
        justifyContent='center'>
        <TouchableOpacity
          onPress={() => {
            handleOptionSelect(undefined);
          }}>
          <Text
            flex={1}
            variant='webBodySecondary'
            color={selectedSorts.length > 0 ? 'textPrimary' : 'grey04'}>
            Clear All
          </Text>
        </TouchableOpacity>
      </Box>
    </ShadowBox>
  );
};
